module.exports = __webpack_public_path__ + "static/ks-collect/img/order-diamond.de94f3c1.png";